
<owc-input #inputElement variant="filled" rounded
placeholder="Search" [formControl]="searchbox"
class="nd-document-search">
<owc-icon slot="prefix" name="search" family="outlined" />
</owc-input>



